// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","content":"footer_content__Px8MT","hidden":"footer_hidden__1xdNe"};